import { loadScript, loadStyle } from './helpers.js'

let panoBtn = null

function panoLoad( e )
{
  //prevent default
  e.preventDefault()

  //remove listener
  panoBtn.removeEventListener( 'click', panoLoad )

  //class
  panoBtn.classList.add( 'loading' )

  //load style then script
  loadStyle( '/css/photosphere.css', { callback: () => loadScript( '/js/photosphere.js' ) } )
}

function init( id = 'photosphere' )
{
  panoBtn = document.getElementById( id )

  if( panoBtn ){
    panoBtn.addEventListener( 'click', panoLoad )
  }

}

export default {
  init
}
